import { useEffect } from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "@/lib/api";

const CONTENT = {
  termos: { title: "Termos de Uso", body: [
    ["1. Aceitação", `Ao usar o ${APP_NAME}, você concorda com estes Termos. A plataforma conecta músicos, contratantes e eventos.`],
    ["2. Conta", "Você é responsável pelas informações do seu perfil e pela guarda das suas credenciais."],
    ["3. Uso", "É proibido usar a plataforma para fins ilícitos, fraude ou violação de direitos de terceiros."],
    ["4. Pagamentos", "Cachês e assinaturas são processados via gateway. Taxas são exibidas de forma transparente no momento da transação."],
    ["5. Cancelamento", "Você pode cancelar sua assinatura a qualquer momento; o acesso permanece até o fim do ciclo vigente."],
    ["6. Alterações", "Podemos atualizar estes Termos; a versão vigente estará sempre disponível nesta página."],
  ]},
  privacidade: { title: "Política de Privacidade", body: [
    ["1. Dados coletados", "Coletamos dados de cadastro (nome, e-mail, telefone), perfil profissional, uso da plataforma e dados de navegação."],
    ["2. Finalidade", "Usamos os dados para operar a plataforma, conectar músicos e contratantes, processar pagamentos e melhorar a experiência."],
    ["3. Compartilhamento", "Não vendemos seus dados. Compartilhamos apenas com prestadores necessários à operação (ex.: gateway de pagamento)."],
    ["4. Direitos (LGPD)", "Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento pelos canais de contato."],
    ["5. Segurança", "Adotamos medidas técnicas e organizacionais para proteger seus dados."],
    ["6. Cookies", "Usamos cookies para medição e marketing conforme seu consentimento — veja a Política de Cookies."],
  ]},
  cookies: { title: "Política de Cookies", body: [
    ["1. O que são", "Cookies são pequenos arquivos usados para lembrar preferências e medir o uso do site."],
    ["2. Tipos", "Essenciais (funcionamento), de medição (analytics) e de marketing (remarketing)."],
    ["3. Consentimento", "Os cookies de marketing só são ativados após o seu consentimento no banner exibido no site."],
    ["4. Gerenciamento", "Você pode limpar os cookies do navegador ou revogar o consentimento a qualquer momento."],
  ]},
};

export default function Legal({ page }) {
  const c = CONTENT[page] || CONTENT.termos;
  useEffect(() => {
    const prev = document.documentElement.getAttribute("data-theme");
    document.documentElement.setAttribute("data-theme", "dark");
    return () => { if (prev) document.documentElement.setAttribute("data-theme", prev); };
  }, []);
  return (
    <div className="min-h-screen bg-[#09090B] text-white" data-testid={`legal-${page}`}>
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="text-sm text-[#00F0FF] hover:underline">← Voltar ao início</Link>
        <h1 className="mt-4 font-head text-4xl font-bold tracking-tight">{c.title}</h1>
        <p className="text-zinc-500 text-sm mt-1">{APP_NAME}</p>
        <div className="mt-8 space-y-6">
          {c.body.map(([h, p]) => (
            <div key={h}><h2 className="font-head text-lg font-semibold">{h}</h2><p className="mt-1 text-sm text-zinc-400 leading-relaxed">{p}</p></div>
          ))}
        </div>
      </div>
    </div>
  );
}
